import type { RoleType } from '@/features/role/domain/enums/RoleType'
import type { CancelOrderReasonTranslationEntity } from './CancelOrderReasonTranslationEntity'

export class CancelOrderReasonEntity {
  id?: number
  role?: RoleType
  requiresUnavailableItems?: boolean
  translations?: Array<CancelOrderReasonTranslationEntity> | null
}
